export default "__VITE_ASSET__BmJJFZYZ__"